module.exports = __webpack_public_path__ + "static/TikTok_Icon_Black_Circle-944a7ac4355bace37902ef820352d7d2.png";